export { default } from "ember-file-upload/helpers/file-queue";
